import { render } from "./ProSupply.vue?vue&type=template&id=fee052f6&scoped=true"
import script from "./ProSupply.vue?vue&type=script&lang=js"
export * from "./ProSupply.vue?vue&type=script&lang=js"

import "./ProSupply.vue?vue&type=style&index=0&id=fee052f6&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fee052f6"]])

export default __exports__